/**
 * @property {Function} generate
 * @property {Function} setRoutingData
 */
const Router = require('../../../vendor/friendsofsymfony/jsrouting-bundle/Resources');
const routes = require('../../routes.json');
Router.setRoutingData(routes);

export {Router};
